<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入用户昵称/手机号进行搜索"
        v-model="body.keyword"
        clearable
        @change="handleCurrentChange()"
        class="input-with-select dk_input">
        <el-button
          slot="append"
          @click="handleCurrentChange()"
          icon="el-icon-search"/>
      </el-input>
      <div>
        <span style="line-height: 40px;margin-right:10px">注册时间</span>
        <el-date-picker
          v-model="times"
          clearable
          value-format="yyyy-MM-dd"
          @change="onTimeChange()"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="idd"
        label="编号"/>
      <el-table-column
        prop="avatar"
        label="头像"
        width="161">
        <template slot-scope="scope">
          <img
            :src="scope.row.avatar"
            width="141px"
            height="141px">
        </template>
      </el-table-column>
      <el-table-column
        prop="nickname"
        label="用户昵称"/>
      <el-table-column
        prop="mobile"
        label="手机号码"/>
      <el-table-column
        prop="create_time"
        label="注册时间"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="450">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="event().onChangeDistributorDialog(scope.row)">
            添加至渠道商
          </el-button>
          <el-button
            v-if="scope.row.is_banned"
            size="mini"
            type="success"
            class="mini-el-button"
            plain
            @click="event().onBandClick(scope.row)">
            恢复
          </el-button>
          <el-button
            v-else
            size="mini"
            type="danger"
            class="mini-el-button"
            plain
            @click="event().onBandClick(scope.row)">
            禁用
          </el-button>
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toDetailClick(scope.row.uuid)">
            用户详情
          </el-button>
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toOrderListClick(scope.row.uuid)">
            用户订单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

    <!-- 添加至渠道商 -->
    <el-dialog
      width="480px"
      title="确认添加该用户为渠道商"
      :visible.sync="changeDistributorDialog">
          <el-form
            :model="changeDistributorBody"
            label-position="left"
            ref="ruleForm3"
            label-width="120px"
            class="demo-ruleForm">
            <el-form-item
              label="头像:"
              prop="name">
              <template slot-scope="scope">
                <img
                  :src="changeDistributorBody.avatar"
                  width="141px">
              </template>
            </el-form-item>
            <el-form-item
              label="用户昵称："
              prop="name">
              <div>{{changeDistributorBody.name}}</div>
            </el-form-item>
            <el-form-item
              label="手机号："
              prop="name">
              <div>{{changeDistributorBody.mobile}}</div>
            </el-form-item>
            <el-form-item
              label="公司："
              prop="name">
              <el-input
                class="dk-input"
                v-model="changeDistributorBody.studio_name"/>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            class="dialog-footer">
            <el-button @click="changeDistributorDialog = false">取 消</el-button>
            <el-button
              type="primary"
              @click="event().onSureChangeDistributorClick('ruleForm3')">确 定</el-button>
          </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getUserList, bandUser, addSupplier } from '../../api/user'
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'
import {chengMoney} from "../../api/order";

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      body: {
        keyword: '',
        page_index: 1,
        page_size: 20,
      },
      times: [],
      total: 0,
      tableData: [
        {},
      ],
      changeDistributorDialog: false,
      changeDistributorBody: {
        studio_name:''
      },
    };
  },

  components: {
  },
  created() {
    this.network().getUserList()
  },
  methods: {
    handleCurrentChange() {
      this.network().getUserList()
    },
    event() {
      return {
        toDetailClick: (uuid) => {
          this.$router.push({ path: 'detail', query: { uuid } })
        },
        toOrderListClick: (uuid) => {
          this.$router.push({ path: 'user-order-list', query: { uuid } })
        },
        // eslint-disable-next-line
        onBandClick: ({ uuid, is_banned }) => {
          // eslint-disable-next-line
          this.network().bandUser({ uuid, is_banned: is_banned ? 0 : 1 })
        },
        onChangeDistributorDialog: (row) => {
          this.$set(this.changeDistributorBody, 'avatar', row.avatar)
          this.$set(this.changeDistributorBody, 'uuid', row.uuid)
          this.$set(this.changeDistributorBody, 'mobile', row.mobile)
          this.$set(this.changeDistributorBody, 'name', row.name)
          this.changeDistributorDialog = true
        },
        onSureChangeDistributorClick: (formName) => {
          this.network().addSupplier()
        },
      }
    },
    network() {
      return {
        getUserList: async () => {
          const { status, data } = await getUserList(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
        bandUser: async (body) => {
          const { status } = await bandUser(body)
          if (status !== 200) return
          this.network().getUserList()
        },
        addSupplier: async () => {
          const { status } = await addSupplier(this.changeDistributorBody)
          if (status !== 200) return
          this.network().getUserList()
          this.changeDistributorDialog = false
          this.$notify({
            title: '添加至渠道商成功',
            message: '添加至渠道商成功',
            type: 'success',
          });
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/user/list.vue